import ResourceDetail from "@/src/pages/resource-detail";

export default function MaterialsDetailPage() {
  return <ResourceDetail type="study_materials" backTo="/materials" label="Study Materials" />;
}

